import React from 'react';
import { Link } from '../components/widgets/buttons';
import { T } from './helpers';

export const WixPublishErrorMessage = () => {
    return (
        <>
            <b>{T._('Oops!', 'Admin')}</b>
            <p>
                {T._('Your product could not be published because the', 'Admin')}{' '}
                <b>{T._('Customization Token field on its product page is missing.', 'Admin')}</b>
            </p>

            <p>
                {T._(
                    "If you don't add the customization token field on the product page, your customers won't be able to purchase the custom product.",
                    'Admin'
                )}{' '}
                <Link target='_blank' href={'https://zakeke.zendesk.com/hc/en-us/articles/5158558508828'}>
                    {T._('Read here.', 'Admin')}
                </Link>
            </p>
        </>
    );
};
